document.addEventListener("DOMContentLoaded", function () {
  const faqItems = [];
  const details = document.querySelectorAll("[data-faq-structured-data]");

  details.forEach(item => {
    const question = item.querySelector("[data-faq-question]");
    const answer = item.querySelector("[data-faq-answer]");

    if (question && answer) {
      faqItems.push({
        "@type": "Question",
        "name": question.innerText.trim(),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": answer.innerHTML.trim()
        }
      });
    }
  });

  if (faqItems.length > 0) {
    const schema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqItems
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(schema, null, 2);

    document.body.appendChild(script);
  }
});
